import React from 'react';
import AdminVendorManagement from '../components/Admin/AdminVendorManagement';

const AdminVendorManagementPage = () => {
  return <AdminVendorManagement />;
};

export default AdminVendorManagementPage;